import imgOutside from '../../assetsFr/buildings/house/outside.jpg';
import imgWasteWater from '../../assetsFr/buildings/house/waste-water.webp';
import imgHeatingFr from '../../assetsFr/buildings/house/heatingFr.jpg';
import imgWaterFr from '../../assetsFr/buildings/house/waterFr.jpg';
import { Building, BuildingTechSectors } from '../../interfaces/buildings';
import { TechSector } from '../tech-sector';
import { ProductType } from '../products';

const frenchWater: BuildingTechSectors = {
            type: TechSector.WATER,
            img: imgWaterFr,
            products: [
                {
                    position: {x: 126, y: 642},
                    type: ProductType.MULTI_ECO
                },
                {
                    position: {x: 307, y: 483},
                    type: ProductType.FILTRA
                },
                {
                    position: {x: 876, y: 712},
                    type: ProductType.HYA_RAIN_N
                },
                {
                    position: {x: 1009, y: 762},
                    type: ProductType.DELTA_BASIC_COMPACT_MVP
                },
                {
                    position: {x: 1760, y: 900},
                    type: ProductType.IXO_PRO
                },
            ]
        }

const frenchHeating: BuildingTechSectors = {
            type: TechSector.HEATING,
            img: imgHeatingFr,
            products: [
                {
                    position: {x: 1100, y: 719},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                    position: {x: 1195, y: 712},
                    type: ProductType.CALIO_THERM_S_PRO
                },
                {
                    position: {x: 1305, y: 711},
                    type: ProductType.CALIO_S_PRO
                }
            ]
        }

const houseConfig: Building = {
    techSectors: [
        frenchWater,
        frenchHeating,
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                    position: { x: 1412, y: 821 },
                    type: ProductType.MINI_COMPACTA,
                },
                {
                    position: { x: 1231, y: 817 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                    position: { x: 1783, y: 760 },
                    type: ProductType.CK_800,
                },
                {
                    position: { x: 1564, y: 685 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
            ],
        },
    ],
    img: imgOutside,
};

export default houseConfig;
